import _typeof from "@babel/runtime/helpers/typeof";
import rfdc from 'rfdc';
export var clone = rfdc();

/**
 * Returns merged objects
 * @param {...object} sources array of objects
 * @returns {object} merged object
 */
export var merge = function merge() {
  for (var _len = arguments.length, sources = new Array(_len), _key = 0; _key < _len; _key++) {
    sources[_key] = arguments[_key];
  }
  return sources.reduce(function (acc, current) {
    // loop through current's keys
    Object.keys(current).forEach(function (k) {
      var accVal = acc[k];
      var curVal = current[k];
      if (curVal !== null && _typeof(curVal) === 'object' && accVal !== null && _typeof(accVal) === 'object' && !Array.isArray(curVal) && !Array.isArray(accVal)) {
        acc[k] = merge(accVal, curVal);
      } else {
        acc[k] = curVal;
      }
    });
    return acc;
  }, {});
};

/**
 * determines if an object is empty or not
 * @param {object} obj
 * @returns {boolean} true if object is empty, false otherwise
 */
export var isEmpty = function isEmpty(obj) {
  return Object.keys(obj).length === 0;
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/utils/dist/esm/ObjectUtils.js
// module id = 2594
// module chunks = 11